import type { ComponentType } from 'react'

import CustomerHubCore, {
  type SizePassportsProps,
} from '../components/CustomerHubCore'
import { type Role } from '../contexts/CustomerHubContext'

import type { EnvironmentWithChina } from '../App'
import type { CustomerHubAnalyticsConfig } from '../lib/analytics'

interface IndexProps {
  env: EnvironmentWithChina
  role?: Role
  context?: string
  customerStatus?: 'activeInCart' | 'waiting' | 'serving' | ''
  accountNumber?: string
  customerProfileEmail?: string
  authToken?: string
  analyticsConfig?: CustomerHubAnalyticsConfig
  SizePassports?: ComponentType<SizePassportsProps>
}

export default function Index({
  env,
  role = 'style-advisor',
  context,
  customerStatus,
  accountNumber = 'SF003022921', // Default for demo/development
  customerProfileEmail,
  authToken,
  analyticsConfig,
  SizePassports,
}: IndexProps): JSX.Element {
  return (
    <CustomerHubCore
      accountNumber={accountNumber}
      customerProfileEmail={customerProfileEmail}
      env={env}
      customerStatus={customerStatus}
      role={role}
      context={context}
      authToken={authToken}
      analyticsConfig={analyticsConfig}
      SizePassports={SizePassports}
    />
  )
}
